import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GoalsProgressBarFormShape } from '../../goals-progress-bar.model';

@Component({
  selector: 'smart-cart-goals-settings-tab',
  templateUrl: './settings-tab.component.html',
  styleUrls: ['../../../../components/shared.scss'],
  standalone: false,
})
export class SmartCartGoalsSettingsTabComponent {
  @Input({ required: true }) formGroup!: FormGroup<GoalsProgressBarFormShape>;
}
